<div class="container">
    <div class="meta-container">
        <span *ngIf="item" class="artist">{{ item.artist }}</span>
        <span *ngIf="item" class="title">{{item.title}}</span>
        <span *ngIf="item && item.type === 1" class="lyrics">{{item.lyrics}}</span>
        <div class="space"></div>
    </div>
</div>
